import { saveAgendaMailOption, discardAgendaMailOption } from './actions/internalActions';
import AgendaMailFull from './components/AgendaMailFull';
import isAgendaMailOptionDirty from './utils/isAgendaMailOptionDirty';
import { Option } from 'owa-options-core';
import * as React from 'react';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Txp options settings
 */
let AgendaMailOption: Option = {
    key: 'agenda',
    titleStringKey: 'optionTitle_AgendaMail',
    searchTermsStringKey: 'optionTitle_AgendaMail',
    hideTitleInFullOptions: true,
    fullOptionFormSettings: {
        render: () => <AgendaMailFull />,
        isDirty: isAgendaMailOptionDirty,
        onSave: () => {
            saveAgendaMailOption();
            return Promise.resolve();
        },
        onDiscard: discardAgendaMailOption,
    },
    isHidden: () => !isFeatureEnabled('cal-mf-agendaMailOption'),
    allowedOptionKeys: ['AgendaMail'],
};

export default AgendaMailOption;
